
export class Information {
  client_started: string = "--";
  client_name: string = "--";
  client_address_1: string = "--";
  client_address_2: string = "--";
  client_country: string = "--";
  flConfig_code: number = 0;
  flStatus_code: number = 0;
  flStatus_age: number = 0;
  flStatus_cards: number = 0;
  flStatus_nrFieldStations: number = 0;
  flStatus_nrFastlinks: number = 0;
  flStatus_pollQuality: number = 0;
  flStatus_stateStr: string = "--";
  flStatus_fieldStationInErr: number = 0;
  flStatus_errorcode: number = 0;
  flStatus_errorcodeStr: string = "--";
  flStatus_lastUpdate: number = 0;
  flConfig_nrFieldStations: number = 0;
  xlrConfig_code: number = 0;
  xlrConfig_nrrack: number = 0;
  xlrConfig_sysoptions: number = 0;
  xlrStatus_code: number = 0;
  xlrStatus_nrrack: number = 0;
  xlrStatus_status: number = 0;
  ip_address: string = "--";
  ip_mask: string = "--";
  HWaddr: string = "--";
  mem_total: number = 0;
  mem_free: number = 0;
  board_kop: string = "--";
  running_kop: string = "--";
  running_program: string = "--";
  climate_running_time: string = "--";
  board_id: string = "--";
  fuse: string = "0x0000";
  linux_driver: string = "--";
  tms_driver: string = "--";
  tms_watchdog: string = "--";
  uptime: number = 0;

  //-- Not part of the JSON data.
  fuse12DC: boolean = false;
  fuse24DC: boolean = false;
  fuse24AC: boolean = false;
  fuse40DC: boolean = false;
  signalquality: string = "unknown";
  board_temperature: number = 0;
  board_voltage: number = 0;

}



